import { getInternalFeatureFlag } from '../feature-flags'
import { LaunchDarklyVariations } from '../feature-flags/models'
import { NotificationChannel } from '../notification-channel'
import { ShellNotificationChannelFacade } from './shell-websocket-notification-facade'
import type {
  GotoNotificationChannelConfig,
  NotificationChannel as INotificationChannel,
} from '@goto/shell-notification-channel'
import { GotoNotificationChannel } from '@goto/shell-notification-channel'
import { environment } from '../../environments'
import { getShellLogger } from '../../common/logger'
import { notificationChannelTokenResolver } from './notification-channel-token-resolver'

export const createNotificationChannel = (userKey: string): INotificationChannel => {
  if (getInternalFeatureFlag(LaunchDarklyVariations.SHELL_NOTIFICATION_CHANNEL_V2)) {
    const baseURL = environment().notificationChannelUrl
    const notificationChannelConfig: GotoNotificationChannelConfig = {
      userKey,
      baseURL,
      tokenResolver: notificationChannelTokenResolver,
      logger: getShellLogger(),
    }
    const notificationChannel = new GotoNotificationChannel(notificationChannelConfig)
    return new ShellNotificationChannelFacade(notificationChannel)
  }
  return new NotificationChannel(userKey) as INotificationChannel
}
